import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'home-underconstruction',
    templateUrl: './underconstruction.component.html'
})
export class UnderConstructionComponent implements OnInit {

    constructor(private router: Router) { }

    ngOnInit() { }

    cmdRedirect(strPage: string) {
        let link = [strPage];
        this.router.navigate(link);
    }

}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/shared/common/underconstruction.component.ts